export default "__VITE_ASSET__BiMA$cLp__"